import { Link } from "react-router-dom";
import { usePageContent } from "@/context/PageContentContext";
import Seo from "@/components/site/Seo";
import { Img } from "@/assets";

export default function Careers() {
  const c = usePageContent();
  return (
    <>
      <Seo />
      <section className="gp-page-hero" data-testid="careers-hero">
        <div className="gp-page-hero__img" aria-hidden="true"><Img id="careers-workplace" alt="" /></div>
        <div className="gp-wrap gp-page-hero__inner">
          <div className="gp-eyebrow"><span className="gp-eyebrow-num">05</span><span className="gp-eyebrow-sep" /> Careers</div>
          <h1 className="gp-h1 gp-page-hero__title">Initiative, judgement, collaboration.</h1>
          <p className="gp-page-hero__lede" data-testid="careers-body">{c["careers.body"]}</p>
        </div>
      </section>

      <section className="gp-section gp-on-white" data-testid="careers-cta-section">
        <div className="gp-wrap gp-narrow">
          <div className="gp-eyebrow" style={{ color: "var(--gp-ink)" }}>
            <span className="gp-eyebrow-num">01</span><span className="gp-eyebrow-sep" /> Register your interest
          </div>
          <h2 className="gp-h2" style={{ marginBottom: 24 }}>No listed roles today — but the door is open.</h2>
          <p className="gp-body" style={{ marginBottom: 24 }}>
            We do not maintain a live vacancy list. When you register your interest we hold your
            details on file and reach out as suitable roles come up.
          </p>
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginTop: 24 }}>
            <Link to="/contact?category=Careers" className="gp-btn gp-btn--on-white" data-testid="careers-cta-register">
              Register your interest <span className="gp-arrow">→</span>
            </Link>
            <Link to="/company" className="gp-link" data-testid="careers-cta-company">
              About the company <span className="gp-arrow">→</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
